import React, {useState} from 'react';
import classNames from "classnames";
import {GoGoal} from "react-icons/go";
import {darken} from "polished";

export function ChapterTopicBox({topic, className, initToggle=false, color="#87d0e6"}) {

    const [toggleShow, setToggleShow] = useState(initToggle);

    const bodyClass = classNames("p-3 ps-5 ",
        {
            "d-none": !toggleShow
        }
    )

    return (
        <div className={"bg-white border rounded p-3 chapter-topic " + className}
             onClick={() => setToggleShow(!toggleShow)}
             style={{
                 background: `linear-gradient(to right,#ffffff, ${color})`,
             }}
        >
            <div className={"row"} style={{color: `${darken(0.3, color)}`}}>
                <div className={"col-1 d-flex  justify-content-center"}>
                    <GoGoal size={32}/>
                </div>
                <div className={"col"}>
                    <h3 >
                        {topic.text}
                    </h3>
                </div>
            </div>
            <ul className={bodyClass} style={{borderLeft: `5px solid ${darken(0.3, color)}`}}>
                {
                    topic.items.map(item => (
                        <li>
                            <span>{item.text}</span>
                            {
                                item.items.length > 0 ?
                                    (
                                        <ul className={""}>
                                            {

                                                item.items.map(subItem => (
                                                    <li>{subItem}</li>
                                                ))
                                            }
                                        </ul>
                                    ) : null
                            }
                        </li>
                    ))
                }
            </ul>
        </div>
    );


}